import { apiGet } from 'acds-react-core';
import * as _ from 'lodash';
import { put, select, takeEvery } from 'redux-saga/effects';

import * as Actions from '../actions/ingredient';
import { getNextApiString } from './helpers';

function* doGetNextCrossReactorSearch () {
  try {
    const next = yield select((s) => s.ingredientReducer.crossReactorsNext);
    const apiString = yield getNextApiString(next);
    const response = yield apiGet(apiString);

    yield put({
      type: Actions.CROSS_REACTOR_SEARCH_SUCCESS,
      response,
      paginated: true,
    });
  } catch (error) {
    yield put({
      type: Actions.CROSS_REACTOR_SEARCH_ERROR,
      error,
    });
  }
}

function* doGetSelectIngredientInfo ({ ingredient, isLookUp }) {
  let ingredientId;

  if(ingredient.id) {
    ingredientId = ingredient.id;
  } else {
    ingredientId = ingredient.ingredient_id;
  }

  try {
    const url = `api/ingredients/details/${ingredientId}`;
    const response = yield apiGet(url);
     const mergedIngredient = _.merge(ingredient, response);

    const selectedIngredients = yield select((s) => s.ingredientReducer.selectedIngredients);
    const conflictingIngredientIds = _.get(response, 'exclusion_group_ingredient_ids', []);
    const conflictingIngredient = _.find(
      selectedIngredients,
      (selected) => conflictingIngredientIds.includes(selected.id),
    );

    if (conflictingIngredient) {
      yield put({
        type: Actions.SELECT_INGREDIENT_CONFLICT,
        newIngredientName: mergedIngredient.name,
        conflictingIngredientName: conflictingIngredient.name,
      });
      return;
    }
    yield put({
      type: Actions.SELECT_INGREDIENT_SUCCESSES,
      ingredient: mergedIngredient,
      isLookUp: !!isLookUp,
    });
  } catch (error) {
    console.error(error);
  }
}

export default function* ingredient () {
  yield takeEvery(Actions.SELECT_INGREDIENT, doGetSelectIngredientInfo);
}
